import { useState } from "react";

/**
 * Confirmation modal for prod-affecting actions. A note is optional. The actual
 * step-up (re-auth) is handled by the caller when the API returns stepup_required;
 * this modal just gathers intent + an optional note.
 */
export function PublishModal({
  domain,
  mode,
  onCancel,
  onConfirm,
}: {
  domain: string;
  mode: "promote" | "rollback";
  onCancel: () => void;
  onConfirm: (note: string) => void;
}) {
  const [note, setNote] = useState("");
  const title = mode === "promote" ? "Опубликовать обновление?" : "Вернуть прошлую версию?";
  const body =
    mode === "promote"
      ? "Новую версию сразу увидят клиенты"
      : "Клиенты снова увидят выбранную версию";

  return (
    <div className="ov" onClick={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="modal">
        <div className="ic">{mode === "promote" ? "🚀" : "↩"}</div>
        <h3>{title}</h3>
        <p>
          {body} на <b style={{ color: "var(--text)" }}>{domain}</b>. Прошлую версию всегда можно
          вернуть, если что-то будет не так.
        </p>
        <label className="small" style={{ display: "block", marginBottom: 7, fontWeight: 650 }}>
          Комментарий (необязательно)
        </label>
        <input
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="например: новые цены на лето"
        />
        <div className="rowend">
          <button className="btn" onClick={onCancel}>Пока нет</button>
          <button className="btn primary" onClick={() => onConfirm(note)}>
            {mode === "promote" ? "Да, опубликовать" : "Да, вернуть"}
          </button>
        </div>
      </div>
    </div>
  );
}
